export const formInputTheme = {
  base: "form-input w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  variant: {
    normal:
      "bg-white focus:bg-gray-50 dark:focus:bg-gray-900 dark:bg-gray-700 relative border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-200 placeholder:text-gray-600 dark:placeholder:text-gray-400 transition-all placeholder:text-muted-foreground focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 block p-2 rounded-lg font-semibold w-full",
    small:
      "bg-white focus:bg-gray-50 dark:focus:bg-gray-900 dark:bg-gray-700 relative border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-200 placeholder:text-gray-600 dark:placeholder:text-gray-400 transition-all placeholder:text-muted-foreground focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 block p-1 rounded-sm font-semibold w-full",
    inline:
      "bg-white focus:bg-gray-50 dark:focus:bg-gray-900 dark:bg-gray-700 relative border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-200 placeholder:text-gray-600 dark:placeholder:text-gray-400 transition-all placeholder:text-muted-foreground focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 p-1 rounded-sm font-semibold",
    checkbox:
      "border-2 form-checkbox focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded-md cursor-pointer",
    radio:
      "border-2 form-radio focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded-full cursor-pointer",
  },
  size: {
    default: "h-10 py-2",
    sm: "h-8 px-3 text-xs",
    lg: "h-12 px-4 text-base",
  },
  state: {
    error: "border-red-500 focus-visible:ring-red-500",
  },
} as const;

export type FormInputThemeProps = {
  variant: keyof typeof formInputTheme.variant;
  size?: keyof typeof formInputTheme.size;
};
